import Button from "@/components/base/Button";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function HowItWorks() {
  const { data } = useSiteData();
  const t = useT();
  const etiqueta = t("home.como.etiqueta");
  const descripcion = t("home.como.descripcion");
  const pasos = data.contentBlocks.home?.steps ?? [];

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {t("home.como.titulo")}
          </h2>
          {descripcion && <p className="mt-4 text-base md:text-lg text-foreground-600">{descripcion}</p>}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pasos.map((paso, idx) => (
            <div key={paso.id} className="relative rounded-lg bg-background-100 p-6">
              <span className="absolute top-5 right-5 font-heading text-4xl font-bold text-accent-200">
                {paso.numero}
              </span>
              <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
                <i className={`${paso.icono} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-900">{paso.titulo}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{paso.descripcion}</p>
              {idx < pasos.length - 1 && (
                <i className="hidden lg:block absolute top-1/2 -right-4 text-background-300 ri-arrow-right-line text-xl" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Button to="/contacto" variant="outline" icon="ri-calendar-check-line">
            {t("home.como.boton")}
          </Button>
        </div>
      </div>
    </section>
  );
}